// src/components/subscription-limit-modal/index.jsx
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSingleton } from "../../hooks/use-singleton";
import "./style.sass";
import { ROUTE_COMPETITIVE_EXAM } from "../../route";
import assets from "../../assets";

export const SubscriptionLimitModal = ({ onClose }) => {
  const { subscriptionLimitModal, updateSubscriptionLimitModal } = useSingleton();
  const navigate = useNavigate();
  const location = useLocation();

  if (!subscriptionLimitModal) return null;

  const handleClose = () => {
    updateSubscriptionLimitModal(false);
    if (onClose) onClose();
  };

  const handleSubscribe = () => {
    // 1. Close the modal globally and locally
    updateSubscriptionLimitModal(false);
    if (onClose) onClose();

    // 2. Navigate to the competitive exam route
    const targetRoute = ROUTE_COMPETITIVE_EXAM;
    navigate(targetRoute);
  };

  return (
    <div className="sub_limit_overlay" onClick={handleClose}>
      <div className="sub_limit_card" onClick={(e) => e.stopPropagation()}>

        <button className="sub_limit_close" onClick={handleClose}>✕</button>

        <div className="sub_limit_icon">
          <img src={assets.ic_unlock_limit} alt="unlock"/>
        </div>

        <div className="sub_limit_badge">FREE LIMIT REACHED</div>

        <h2 className="sub_limit_title">🔒 Unlock Your Potential</h2>

        <p className="sub_limit_message">
          You've used all your <strong>free AI prompts.</strong> Upgrade your
          plan to continue using all AI-powered features.
        </p>

        <button className="sub_limit_subscribe_btn" onClick={handleSubscribe}>
          View Plans & Subscribe 
          <img src={assets.ic_arrow_white} alt="arrow"/>
        </button>

        <button className="sub_limit_skip" onClick={handleClose}>
          Maybe Later
        </button>

      </div>
    </div>
  );
};